<footer class="site-footer">

  <!-- Top decorative border -->
  <div class="footer-top-decoration"></div>

  <div class="footer-main">
    <div class="container-fluid">
      <div class="row g-5 align-items-start">

        <!-- Col 1: Brand + Newsletter -->
        <div class="col-lg-4 col-md-12">

          <!-- Brand -->
          <div class="footer-brand">
            <div class="footer-brand-logo-wrap">
              <img src="assets/images/odisha-logo.png" alt="Odisha Logo" class="footer-logo-img">
            </div>
            <div class="footer-brand-info">
              <span class="footer-govt-label">{{t.header.topbar.govt}}</span>
              <h3 class="footer-brand-name">{{t.hero.subtitle}}</h3>
            </div>
          </div>

          <p class="footer-brand-desc">
            {{t.footer.deptDesc}}
          </p>

          <hr class="footer-divider">

          <!-- Newsletter -->
          <div class="footer-newsletter">
            <h4 class="footer-newsletter-title">{{t.footer.stayUpdated}}</h4>
            <p class="footer-newsletter-desc">{{t.footer.stayUpdatedDesc}}</p>
            <div class="footer-subscribe-row">
              <label for="footer-email" class="visually-hidden">Email address for newsletter subscription</label>
              <input type="email" class="footer-email-input" [class.footer-email-input--error]="isEmailInvalid"
                [placeholder]="t.footer.emailPlaceholder" id="footer-email" [(ngModel)]="subscribeEmail"
                (keyup.enter)="onSubscribe()" [disabled]="isLoading" autocomplete="email"
                aria-label="Your email address for newsletter subscription">
              <button class="footer-subscribe-btn" type="button" (click)="onSubscribe()" [disabled]="isLoading"
                aria-label="Subscribe to newsletter">
                <span *ngIf="isLoading" class="footer-subscribe-spinner" aria-hidden="true"></span>
                <i *ngIf="!isLoading" class="material-symbols-outlined" aria-hidden="true">mail</i>
                {{ isLoading ? 'Subscribing…' : t.footer.subscribeBtn }}
              </button>
            </div>

            <!-- Inline validation hint -->
            <p *ngIf="isEmailInvalid" class="footer-subscribe-hint footer-subscribe-hint--error" role="alert">
              <i class="material-symbols-outlined" aria-hidden="true">error</i>
              Please enter a valid email address.
            </p>

            <!-- Success message -->
            <p *ngIf="successMessage" class="footer-subscribe-hint footer-subscribe-hint--success" role="status">
              <i class="material-symbols-outlined" aria-hidden="true">check_circle</i>
              {{ successMessage }}
            </p>

            <!-- Error message -->
            <p *ngIf="errorMessage && !isEmailInvalid" class="footer-subscribe-hint footer-subscribe-hint--error"
              role="alert">
              <i class="material-symbols-outlined" aria-hidden="true">error</i>
              {{ errorMessage }}
            </p>
          </div>

        </div>
        <!-- Col 2: Quick Links -->
        <div class="col-lg-4 col-md-6 col-sm-6">
          <h4 class="footer-section-title">{{t.footer.quickLinks}}</h4>
          <ul class="footer-links-list">
            <li><a routerLink="/" class="footer-nav-link">{{t.footer.home}}</a></li>
            <li><a routerLink="/objective" class="footer-nav-link">{{t.footer.about}}</a></li>
            <li><a routerLink="/" fragment="artcategory" class="footer-nav-link">{{t.footer.explore}}</a></li>
            <li><a routerLink="/contact-us" class="footer-nav-link">{{t.footer.help}}</a></li>
            <li><a routerLink="/analytics" class="footer-nav-link">{{t.footer.analytics}}</a></li>
          </ul>
        </div>
        <!-- Col 3: Contact Panel -->
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="footer-contact-panel">

            <!-- Panel Header -->
            <div class="footer-contact-panel-header">
              <div class="footer-contact-panel-icon">
                <i class="material-symbols-outlined">contact_support</i>
              </div>
              <div>
                <h4 class="footer-contact-panel-title">{{t.footer.contactTitle}}</h4>
                <p class="footer-contact-panel-sub">{{t.footer.contactSub}}</p>
              </div>
            </div>

            <!-- Contact Items -->
            <div class="footer-contact-items">

              <div class="footer-ci">
                <span class="footer-ci-icon footer-ci-icon--loc">
                  <i class="material-symbols-outlined">location_on</i>
                </span>
                <div class="footer-ci-body">
                  <span class="footer-ci-label">{{t.footer.addressLabel}}</span>
                  <span class="footer-ci-val">{{t.footer.address}}</span>
                </div>
              </div>

              <div class="footer-ci-divider"></div>

              <div class="footer-ci">
                <span class="footer-ci-icon footer-ci-icon--call">
                  <i class="material-symbols-outlined">call</i>
                </span>
                <div class="footer-ci-body">
                  <span class="footer-ci-label">{{t.footer.phoneLabel}} <span
                      class="footer-ci-badge">{{t.footer.tollFree}}</span></span>
                  <a href="tel:{{t.footer.phone}}" class="footer-ci-val footer-ci-link">{{t.footer.phone}}</a>
                </div>
              </div>

              <div class="footer-ci-divider"></div>

              <div class="footer-ci">
                <span class="footer-ci-icon footer-ci-icon--mail">
                  <i class="material-symbols-outlined">mail</i>
                </span>
                <div class="footer-ci-body">
                  <span class="footer-ci-label">{{t.footer.email}}</span>
                  <a href="mailto:directorateofculture@gmail.com"
                    class="footer-ci-val footer-ci-link">directorateofculture@gmail.com</a>
                </div>
              </div>

            </div>

            <!-- QR + CTA row -->
            <div class="footer-contact-panel-footer">
              <a href="assets/data/Artist_Affidavit.pdf" target="_blank">
                <div class="footer-qr-card">
                  <div class="footer-qr-wrap">
                    <img src="assets/data/affidavit.png" alt="Download Ama Kalakara Affidavit" class="footer-qr">

                  </div>
                  <div class="footer-qr-info">
                    <span class="footer-qr-app"> {{t.footer.downloadAffidavit}}</span>
                  </div>
                </div>
              </a>
              <a routerLink="/contact-us" class="footer-contact-cta">
                <i class="material-symbols-outlined">arrow_forward</i>
                {{t.footer.contact}}
              </a>
            </div>

          </div>
        </div>



      </div>
    </div>
  </div>

  <!-- Bottom Bar -->
  <div class="footer-bottom">
    <div class="container-fluid">
      <div class="footer-bottom-inner">
        <div class="footer-bottom-links">
          <a routerLink="/sitemap" class="footer-bottom-link">{{t.footer.sitemap}}</a>
          <a routerLink="/analytics" class="footer-bottom-link">{{t.footer.analytics}}</a>
          <a routerLink="/terms-of-service" class="footer-bottom-link">{{t.footer.terms}}</a>
          <a routerLink="/privacy-policy" class="footer-bottom-link">{{t.footer.privacy}}</a>
          <a routerLink="/contact-us" class="footer-bottom-link">{{t.footer.contact}}</a>
        </div>

        <div class="footer-active-users">
          <span class="live-pulse"></span>
          <span class="live-text">Live Users: <strong class="count-val">{{ activeUsersCount }}</strong></span>
        </div>

        <p class="footer-copy">{{t.footer.copy}}</p>
      </div>
    </div>
  </div>
</footer>